import React from 'react';
import { createRoot } from 'react-dom/client';
import axios from "axios";
import Swal from "sweetalert2";
import PropTypes from "prop-types";

import { useTranslation } from "react-i18next";

import {
    Button,
    Input, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
    InputGroup, InputGroupText,
    Progress, DropdownMenu, DropdownItem
} from "reactstrap";

import { Menu, Item, Separator, useContextMenu } from "react-contexify"
import "react-contexify/dist/ReactContexify.css";

import Dropzone from 'react-dropzone'

import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import Img from 'components/Img';
import * as commonFunc from 'scripts/common';
import * as filesFunc from 'scripts/DTAFiles';

import CDataTable from "components/CDataTable";


var filesType = [];
var modalRoot;

function FilesCustom(globalProps) {
    React.useEffect(() => {
        //console.debug("mount");
        //loadFilesType
        if (globalProps.altFilesTypes) {
            commonFunc.getMethod(globalProps.altFilesTypes, null).then((response) => {
                if (response.data && response.data.isSuccess) {
                    filesType = response.data.result.filter(type => type.refExtID !== "AVA");

                    if (globalProps.openUploadOnCreate) {
                        dlgFileUpload();
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Echec de chargement des Types de Fichier :<br>" + response.data.errorMessage
                    });
                }
            });
        }
        else {
            filesType = globalProps.filesType || [];

            if (globalProps.openUploadOnCreate) {
                dlgFileUpload();
            }
        }

        return () => {
            //console.debug("unmount");
            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }
        }
    }, []);

    React.useEffect(() => {
        const excludeKeys = ["placeHolder"];

        var stringGProps = JSON.stringify(globalProps, (key, value) => {
            var foundString = excludeKeys.find(str => str === key);
            if (!commonFunc.isBlank(foundString)) {
                return undefined;
            }
            return value;
        });
        var stringPrevGProps = JSON.stringify(prevProps.current, (key, value) => {
            var foundString = excludeKeys.find(str => str === key);
            if (!commonFunc.isBlank(foundString)) {
                return undefined;
            }
            return value;
        });
        if (!globalProps.checkProps || stringGProps !== stringPrevGProps) {
            prevProps.current = globalProps;
            if (globalProps.shouldRender) {
                loadFiles();
            }
            else {
                setFiles([]);
                setTotLength(0);
                setTotFiles(0);
                hideAllMenu();
            }
        }
    }, [globalProps]);

    React.useImperativeHandle(globalProps.forwardedRef, () => ({
        displayAddDialog: dlgFileUpload,
        toggleGroupment: () => setGroupment(groupment === "categ" ? "none" : "categ")
    }));

    const prevProps = React.useRef(null);


    const [files, setFiles] = React.useState([]);
    const [totLength, setTotLength] = React.useState(0);
    const [totFiles, setTotFiles] = React.useState(0);
    const [filterType, setFilterType] = React.useState(globalProps.defaultFilterType || "*");
    const [folderType, setFolderType] = React.useState(globalProps.defaultFolderType || "*");

    const [groupment, setGroupment] = React.useState("none");

    const showContextMenu = useContextMenu().show;
    const hideAllMenu = useContextMenu().hideAll;

    var btnAddFilesLabel = globalProps.btnAddFilesLabel || "Ajouter des Fichiers";
    var btnAddFilesColor = globalProps.btnAddFilesColor || "success";
    var btnAddFilesIcon = globalProps.btnAddFilesIcon || "fa-plus-circle";


    React.useEffect(() => {
        searchFiles();
    }, [filterType, folderType]);

    React.useEffect(() => {
        if (files.length > 0) loadFiles();
    }, [groupment]);

    function loadFiles(bindID, fileTypeID, src) {
        setFiles([]);
        setTotLength(0);
        setTotFiles(0);

        if (!bindID) bindID = globalProps.bindID;
        if (!fileTypeID) fileTypeID = globalProps.fileTypeID;
        if (!src) src = globalProps.src;
        hideAllMenu();
        if (!globalProps.files) {
            if (bindID > 0) {
                filesFunc.loadFilesLst(bindID, fileTypeID, { srcElem: src, className: globalProps.className, showContextMenu: showContextMenu, hideAllMenu: hideAllMenu, altFilesUrl: globalProps.altFilesUrl, playAction: globalProps.playAction, playActionGroup: globalProps.playActionGroup, renderMode: globalProps.renderMode, renderingBadge: globalProps.badgeRendering, renderingAlt: globalProps.altRendering, renderingList: globalProps.listRendering, renderingTable: globalProps.tableRendering, noRemove: globalProps.noRemove, clickCallback: globalProps.onFileClick, dblClickCallback: globalProps.onFileDblClick, noContextMenu: globalProps.noContextMenu, noPreview: globalProps.noPreview, getExtMenu: getExtMenu, dlgFileUpload: dlgFileUpload }, groupment)
                    .then((result) => {
                        if (result) {
                            setFiles(result.files);
                            setTotLength(result.length);
                            setTotFiles(result.nbFiles);
                        }
                    });
            }
        }
        else {
            var removeFileProc = (file) => {
                if (file.instanceFile) {
                    if (globalProps.files) {
                        var newFiles = globalProps.files;
                        var filteredFiles = newFiles.filter((cfile) => {
                            return cfile.idFile !== parseInt(id);
                        });
                        if (globalProps.setFiles) globalProps.setFiles(filteredFiles);
                    }

                    loadFiles();
                }
                else {
                    var id = file.idFile || 0;
                    var title = commonFunc.cellFormatterFileType(file.name);
                    if (id > 0) {
                        Swal.fire({
                            icon: "question",
                            title: "Suppression",
                            html: "Etes-vous sûr de vouloir supprimer ce fichier ?<br/>[" + id + "] " + title,
                            showCancelButton: true,
                            confirmButtonColor: "#28a745",
                            cancelButtonColor: "#dc3545",
                            confirmButtonText: "Oui",
                            cancelButtonText: "Non",
                        }).then((result) => {
                            if (result.value) {
                                Swal.fire({
                                    title: 'Suppression du Fichier en cours...',
                                    didOpen: () => { Swal.showLoading() }
                                });
                                removeFile(id, parseInt(file.fileTypeID), parseInt(file.bindID)).then((response) => {
                                    var data = response.data;
                                    Swal.close();
                                    if (data && data.isSuccess) {

                                        if (globalProps.files) {
                                            var newFiles = globalProps.files;
                                            var filteredFiles = newFiles.filter((cfile) => {
                                                return cfile.idFile !== parseInt(id);
                                            });
                                            if (globalProps.setFiles) globalProps.setFiles(filteredFiles);
                                        }

                                        loadFiles();
                                    } else {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Echec",
                                            html: "Echec de Suppression :<br>" + data.errorMessage
                                        });
                                    }
                                });
                            }
                        });
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Suppression impossible"
                        });
                    }
                }
            };

            filesFunc.convertFiles(globalProps.files, bindID, fileTypeID, { srcElem: src, className: globalProps.className, showContextMenu: showContextMenu, hideAllMenu: hideAllMenu, smallBox: globalProps.smallBox, playAction: globalProps.playAction, playActionGroup: globalProps.playActionGroup, renderMode: globalProps.renderMode, renderingBadge: globalProps.badgeRendering, renderingAlt: globalProps.altRendering, renderingList: globalProps.listRendering, renderingTable: globalProps.tableRendering, noRemove: !globalProps.checkRights(globalProps.rightType, "D") || globalProps.noRemove, removeFile: removeFileProc, clickCallback: globalProps.onFileClick, dblClickCallback: globalProps.onFileDblClick, noContextMenu: globalProps.noContextMenu, noPreview: globalProps.noPreview, getExtMenu: getExtMenu, dlgFileUpload: dlgFileUpload }, groupment)
                .then((result) => {
                    if (result) {
                        setFiles(result.files);
                        setTotLength(result.length);
                        setTotFiles(result.nbFiles);
                    }
                });
        }
    }

    function removeFile(fileID, fileTypeID, bindID, ftype) {
        var req = { fileID: fileID, fileTypeID: fileTypeID, bindID: bindID, bindType: globalProps.fileTypeID, OpName: "REMOVE_" + globalProps.fileTypeID + "FILE", isPermanent: true };
        if (ftype) req.ftype = ftype;
        req.waitForCompletion = (globalProps.waitForCompletion ? globalProps.waitForCompletion(req) : false);
        if (req.fileID && req.bindID) {
            var url = globalProps.altRemoveFilesUrl || "../api/data/RemoveFile";
            return commonFunc.postMethod(url, req);
        }
        else {
            Swal.fire({
                icon: "error",
                title: "Echec",
                html: "Echec de Suppression : Arguments invalides"
            });
        }
        return false;
    }

    function isItemHidden({ props, data, triggerEvent }) {
        var file = props;

        var files = document.querySelectorAll("." + globalProps.className + " .file.selected");
        var cptf = files.length;

        if (cptf > 1) {
            //if (data === "aupdActFRes") return true;
            if (data !== "aupdActFDel" || Array.from(files).filter(fileItem => fileItem.parentNode?.classList.contains("reportSpecFile") || fileItem.parentNode?.classList.contains("noRemoveFile")).length <= 0) return true;
        }
        else {
            if (file.categ === "SAV") {
                if (data === "aupdActFModRpt") return true;
                if (data === "aupdActFModHtml") return true;
                if (data === "aupdActFRpiDef") return true;
                if (data === "aupdActFRpiReplay") return true;
            }
            else if (file.categ === "RDI" || file.categ === "RPT") {
                if (data === "aupdActFModRpt") return true;
                if (data === "aupdActFModHtml") return true;
                if (data === "aupdActFRes") return true;
                if (data === "aupdActFDefault") return true;
            }
            else if (file.categ === "MOD") {
                if (data === "aupdActFRpiDef") return true;
                if (data === "aupdActFRpiReplay") return true;
                if (data === "aupdActFRes") return true;
                if (data === "aupdActFDefault") return true;
            } else if (file.categ === "UPJ") {
                console.debug(file); 

                if (data === "aupdActFModRpt") return true;
                if (data === "aupdActFModHtml") return true;
                if (data === "aupdActFRpiDef") return true;
                if (data === "aupdActFRpiReplay") return true;
                if (data === "aupdActFRes") return true;
                if (data === "aupdActFDefault") return true;
            }
            else {

                if (data === "aupdActFModRpt") return true;
                if (data === "aupdActFModHtml") return true;
                if (data === "aupdActFRpiDef") return true;
                if (data === "aupdActFRpiReplay") return true;
                if (data === "aupdActFRes") return true;
                if (data === "aupdActFDefault") return true;
            }

            if (data === "aupdActFAudioSum" && !file.contentType.startsWith("audio")) return true;
            if (data === "aupdActFSas" && globalProps.noAltActions) return true;
            if (data === "aupdActFSum" && (globalProps.noAltActions || !file.contentType.endsWith("pdf"))) return true;
            if (data === "aupdActFDel" && Array.from(files).filter(fileItem => fileItem.parentNode?.classList.contains("reportSpecFile") || fileItem.parentNode?.classList.contains("noRemoveFile")).length > 0) return true;//reportSpecFile
        }

        return false;
    }

    function fileDownload({ sysEvent, props, triggerEvent, data }) {
        var dt = props;
        const file = {
            fileId: dt.idFile,
            fileName: dt.name,
            container: dt.rootContainer,
            etag: dt.etag,
            accessToken: dt.absoluteUri,
            newWindow: false
        };

        file.newWindow = true;
        var filePathDirectDl = "../api/data/DownloadFileByUri?" + commonFunc.toParams(file);
        window.open(filePathDirectDl, '_newself');
    }

    function fileDel({ sysEvent, props, triggerEvent, data }) {
        var file = props;

        var filesDOM = document.querySelectorAll("." + globalProps.className + " .file.selected");
        var cptf = filesDOM.length;

        if (cptf === 1) {

            var id = file.idFile || 0;
            var title = commonFunc.cellFormatterFileType(file.name);
            hideAllMenu();
            if (id > 0) {
                //Suppression fichier local
                if (file.instanceFile) {
                    if (globalProps.files) {
                        var newFiles = globalProps.files;
                        var filteredFiles = newFiles.filter((cfile) => {
                            return cfile.idFile !== parseInt(id);
                        });
                        if (globalProps.setFiles) globalProps.setFiles(filteredFiles);
                    }

                    loadFiles();
                }
                //Suppression fichier stocké
                else {

                    Swal.fire({
                        icon: "question",
                        title: "Suppression",
                        html: "Etes-vous sûr de vouloir supprimer ce fichier ?<br/>[" + id + "] " + title,
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: "Oui",
                        cancelButtonText: "Non",
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: 'Suppression du Fichier en cours...',
                                didOpen: () => { Swal.showLoading() }
                            });
                            removeFile(id, parseInt(file.fileTypeID), parseInt(file.bindID), file.categ).then((response) => {
                                var data = response.data;
                                Swal.close();
                                if (data && data.isSuccess) {
                                    if (globalProps.files) {
                                        var newFiles = globalProps.files;
                                        var filteredFiles = newFiles.filter((cfile) => {
                                            return cfile.idFile !== parseInt(id);
                                        });
                                        if (globalProps.setFiles) globalProps.setFiles(filteredFiles);
                                    }

                                    loadFiles();
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de Suppression :<br>" + data.errorMessage
                                    });
                                }
                            });
                        }
                    });
                }
            } else {

            }
        } else if (cptf > 1) {
            //Multiple delete


            //Suppression fichier local
            if (file.instanceFile) {
                if (globalProps.files) {
                    var ids = [];
                    filesDOM.forEach((elem, index) => {
                        var id = parseInt(elem.parentNode.getAttribute("data-fileid")) || 0;
                        if (id > 0) {
                            ids.push(id);
                        }
                    });
                    console.debug(ids);
                    var newFilesMD = globalProps.files;
                    var filteredFilesMD = newFilesMD.filter((cfile) => {
                        return ids.indexOf(cfile.idFile) < 0;
                    });
                    if (globalProps.setFiles) globalProps.setFiles(filteredFilesMD);
                }

                loadFiles();
            }
            //Suppression fichier stocké
            else {
                Swal.fire({
                    icon: "question",
                    title: "Suppression",
                    html: "Etes-vous sûr de vouloir supprimer ces " + cptf + " fichiers ?",
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: "Oui",
                    cancelButtonText: "Non",
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: 'Suppression des Fichiers en cours...',
                            didOpen: () => { Swal.showLoading() }
                        });


                        //TODO


                        /*var req = { fileID: id, filetypeID: parseInt(file.FileTypeID), bindID: parseInt(file.BindID) };//TODO : ajout les variables dans l'objet Fichier OU faire autrement
                        if (req.fileID && req.bindID) {
                            commonFunc.postMethod("../api/data/RemoveFile", req).then((response) => {
                                var data = response.data;
                                Swal.close();
                                if (data && data.isSuccess) {
                                    loadFiles();
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de Suppression :<br>" + data.errorMessage
                                    });
                                }
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: "Echec de Suppression : Arguments invalides"
                            });
                        }*/

                        var item;
                        var id;
                        //var title;
                        //var cpt = 0;
                        //var flag = true;
                        //var desc = "";

                        var asyncJobs = [];
                        filesDOM.forEach((elem, index) => {
                            //cpt += 1;
                            item = elem.parentNode;
                            id = parseInt(item.getAttribute("data-fileid")) || 0;
                            //title = item.querySelector(".file-name").getAttribute("title");
                            if (id > 0) {
                                asyncJobs[index] = removeFile(id, parseInt(item.getAttribute("data-filetypeid")) || 0, parseInt(item.getAttribute("data-bindid")));//TODO : ajout les variables dans l'objet Fichier OU faire autrement
                            }
                        });

                        Promise.all(asyncJobs).then(results => {
                            console.debug(results);
                            if (results.length === cptf) {
                                var err = 0;
                                var sum = 0;
                                var msgErr = "";
                                for (var i = 0; i < results.length; i++) {
                                    if (results[i] && results[i].data && results[i].data.isSuccess) {
                                        sum += 1;
                                        // resStr += dataAll[i].result.first_last_name + " " + dataAll[i].result.last_name + '/';
                                    } else {
                                        err += 1;
                                        if (results[i] && results[i].data) {
                                            msgErr += i + " " + results[i].data.errorMessage + "\n";
                                        } else {
                                            msgErr += i + "\n";
                                        }
                                    }
                                }
                                Swal.close();

                                if (err === 0) {
                                    loadFiles();
                                } else {
                                    var tot = 0;
                                    tot = err + sum;
                                    if (tot === cptf) {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Echec",
                                            html: "Echec de suppression de certains fichiers (" + err + "/" + sum + ") :<br>" + msgErr
                                        });
                                    }
                                }
                            } else {
                                //updateBsProgress("progressModal", "Suppression multiple Fichier", "Suppression des Fichiers en cours...", { progressValue: (totfiles * 100) / dataAll.length });
                                Swal.close();
                                Swal.fire({
                                    title: 'Suppression des Fichiers en cours...',
                                    onOpen: () => { Swal.showLoading() },
                                });
                            }
                            return;
                            /*if (dataAll.length === cptf) {
                                var err = 0;
                                var sum = 0;
                                var msgErr = "";
                                var resStr = "";
                                for (var i = 0; i < dataAll.length; i++) {
                                    if (dataAll[i] && dataAll[i].isSuccess) {
                                        sum += 1;
                                        // resStr += dataAll[i].result.first_last_name + " " + dataAll[i].result.last_name + '/';
                                    } else {
                                        err += 1;
                                        if (dataAll[i]) {
                                            msgErr += i + " " + dataAll[i].errorMessage + "\n";
                                        } else {
                                            msgErr += i + "\n";
                                        }
                                    }
                                }
                                Swal.close();

                                if (err === 0) {
                                    loadFiles();
                                } else {
                                    var tot = 0;
                                    tot = err + sum;
                                    if (tot === cptf) {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Echec",
                                            html: "Echec d'enregistrement de certains fichiers (" + err + "/" + sum + ") :<br>" + msgErr
                                        });
                                    }
                                }
                            } else {
                                //updateBsProgress("progressModal", "Suppression multiple Fichier", "Suppression des Fichiers en cours...", { progressValue: (totfiles * 100) / dataAll.length });
                                Swal.close();
                                Swal.fire({
                                    title: 'Suppression des Fichiers en cours...',
                                    onOpen: () => { Swal.showLoading() },
                                });
                            }*/
                        }, rej => {
                            Swal.fire({
                                icon: "error",
                                title: "Erreur",
                                html: "Erreur de suppression des fichiers :<br>" + rej.message
                            });
                        })
                            .catch(error => {
                                Swal.fire({
                                    icon: "error",
                                    title: "Erreur",
                                    html: "Erreur de suppression des fichiers :<br>" + error.message
                                });
                            });

                    }
                });
            }
        }
    }

    function fileSas({ sysEvent, props, triggerEvent, data }) {
        var file = props;

        var filesDOM = document.querySelectorAll("." + globalProps.className + " .file.selected");
        var cptf = filesDOM.length;

        if (cptf === 1) {

            var id = file.idFile || 0;
            var title = commonFunc.cellFormatterFileType(file.name);
            hideAllMenu();
            if (id > 0) {

                Swal.fire({
                    icon: "question",
                    title: "Création d'un lien",
                    html: "Etes-vous sûr de vouloir créer un lien pour ce fichier ?<br/>[" + id + "] " + title,
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: "Oui",
                    cancelButtonText: "Non",
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: 'Création du lien en cours...',
                            didOpen: () => { Swal.showLoading() }
                        });


                        var req = { fileID: id, fileTypeID: parseInt(file.fileTypeID), bindID: parseInt(file.bindID), bindType: globalProps.fileTypeID, OpName: "CREATESAS_" + globalProps.fileTypeID + "FILE" };
                        if (req.fileID && req.bindID) {
                            var url = "../api/" + globalProps.fileTypeID + "/CreateFileSasUrl";
                            commonFunc.postMethod(url, req).then(response => {
                                var data = response.data;
                                Swal.close();
                                if (data && data.isSuccess) {
                                    loadFiles();
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de création :<br>" + data.errorMessage
                                    });
                                }
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: "Echec de création : Arguments invalides"
                            });
                        }
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Erreur",
                    html: "Aucun Fichier de sélectionné"
                });
            }
        } else {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                html: "Impossible créer un lien pour plusieurs fichiers"
            });
        }
    }



    function fileRes({ sysEvent, props, triggerEvent, data }) {
        var file = props;

        var filesDOM = document.querySelectorAll("." + globalProps.className + " .file.selected");
        var cptf = filesDOM.length;
        console.debug(cptf);
        var repId = globalProps.bindID;
        if (parseInt(repId) > 0) {
            if (cptf === 1) {

                var id = file.idFile || 0;
                var title = commonFunc.cellFormatterFileType(file.name);
                hideAllMenu();
                if (id > 0) {

                    Swal.fire({
                        icon: "question",
                        title: "Suppression",
                        html: "Etes-vous sûr de vouloir restaurer cette sauvegarde ?<br/>[" + id + "] " + title,
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: "Oui",
                        cancelButtonText: "Non",
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: 'Restauration du rapport en cours...',
                                didOpen: () => { Swal.showLoading() }
                            });
                            var req = { id: id, bindId: repId, value: false };
                            commonFunc.postMethod("../api/report/RestoreReport", req).then((response) => {
                                var data = response.data;
                                Swal.close();
                                if (data && data.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: "Succès",
                                        html: "Sauvegarde restaurée avec succès.",
                                        didOpen: () => { Swal.hideLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    }).then((result) => {
                                        loadFiles();
                                    });
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de restauration :<br>" + data.errorMessage
                                    });
                                }
                            });
                        }
                    });

                }
            }
        }
    }
    function fileDefComplete({ sysEvent, props, triggerEvent, data }) {
        var file = props;

        var filesDOM = document.querySelectorAll("." + globalProps.className + " .file.selected");
        var cptf = filesDOM.length;
        console.debug(cptf);
        var repId = globalProps.bindID;
        if (parseInt(repId) > 0) {
            if (cptf === 1) {

                var id = file.idFile || 0;
                var title = commonFunc.cellFormatterFileType(file.name);
                hideAllMenu();
                if (id > 0) {

                    Swal.fire({
                        icon: "question",
                        title: "Rapport par défaut",
                        html: "Etes-vous sûr de vouloir utiliser ce fichier comme rapport Completé ?<br/>[" + id + "] " + title,
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: "Oui",
                        cancelButtonText: "Non",
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: 'Modification du rapport en cours...',
                                didOpen: () => { Swal.showLoading() }
                            });
                            var req = { id: id, bindId: repId , value:true};
                            commonFunc.postMethod("../api/report/RestoreAndMarkReport", req).then((response) => {
                                var data = response.data;
                                Swal.close();
                                if (data && data.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: "Succès",
                                        html: "Modification effectuée avec succès.",
                                        didOpen: () => { Swal.hideLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    }).then((result) => {
                                        loadFiles();
                                    });
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de Rapport par défaut :<br>" + data.errorMessage
                                    });
                                }
                            });
                        }
                    });

                }
            }
        }
    }
    function fileDefFinal({ sysEvent, props, triggerEvent, data }) {
        var file = props;

        var filesDOM = document.querySelectorAll("." + globalProps.className + " .file.selected");
        var cptf = filesDOM.length;
        console.debug(cptf);
        var repId = globalProps.bindID;
        if (parseInt(repId) > 0) {
            if (cptf === 1) {

                var id = file.idFile || 0;
                var title = commonFunc.cellFormatterFileType(file.name);
                hideAllMenu();
                if (id > 0) {

                    Swal.fire({
                        icon: "question",
                        title: "Rapport par défaut",
                        html: "Etes-vous sûr de vouloir utiliser ce fichier comme rapport Completé ?<br/>[" + id + "] " + title,
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: "Oui",
                        cancelButtonText: "Non",
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: 'Modification du rapport en cours...',
                                didOpen: () => { Swal.showLoading() }
                            });
                            var req = { id: id, targetId: repId, isPermanent: true };
                            commonFunc.postMethod("../api/report/SetReportFileDefault", req).then((response) => {
                                var data = response.data;
                                Swal.close();
                                if (data && data.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: "Succès",
                                        html: "Modification effectuée avec succès.",
                                        didOpen: () => { Swal.hideLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    }).then((result) => {
                                        loadFiles();
                                    });
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de Rapport par défaut :<br>" + data.errorMessage
                                    });
                                }
                            });
                        }
                    });

                }
            }
        }
    }
    function fileReplay({ sysEvent, props, triggerEvent, data }) {
        var file = props;

        var filesDOM = document.querySelectorAll("." + globalProps.className + " .file.selected");
        var cptf = filesDOM.length;
        console.debug(cptf);
        var repId = globalProps.bindID;
        if (parseInt(repId) > 0) {
            if (cptf === 1) {

                var id = file.idFile || 0;
                var title = commonFunc.cellFormatterFileType(file.name);
                hideAllMenu();
                if (id > 0) {

                    Swal.fire({
                        icon: "question",
                        title: "Evénements Rapports",
                        html: "Etes-vous sûr de vouloir rejouer les événements pour ce rapport Completé ?<br/>[" + id + "] " + title,
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: "Oui",
                        cancelButtonText: "Non",
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: 'Déclenchements des évenements en cours...',
                                didOpen: () => { Swal.showLoading() }
                            });
                            var req = { id: id, filetypeID: file.filetypeID, bindID: repId, fileOp: "UPLOADFILE" };
                            commonFunc.postMethod("../api/report/ReplayFileEvents", req).then((response) => {
                                var data = response.data;
                                Swal.close();
                                if (data && data.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: "Succès",
                                        html: "Modification effectuée avec succès.",
                                        didOpen: () => { Swal.hideLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    }).then((result) => {
                                        loadFiles();
                                    });
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec du déclenchement des évenements :<br>" + data.errorMessage
                                    });
                                }
                            });
                        }
                    });

                }
            }
        }
    }
    function fileModel({ sysEvent, props, triggerEvent, data }) {
        var file = props;
        var dataItem = data;

        var filesDOM = document.querySelectorAll("." + globalProps.className + " .file.selected");
        var cptf = filesDOM.length;
        console.debug(cptf);
        var repId = globalProps.bindID;
        if (parseInt(repId) > 0) {
            if (cptf === 1) {

                var id = file.idFile || 0;
                var title = commonFunc.cellFormatterFileType(file.name);
                hideAllMenu();
                if (id > 0) {
                    var isHtml = (dataItem === "aupdActFModHtml");
                    Swal.fire({
                        icon: "question",
                        title: "Rapport par défaut",
                        html: "Etes-vous sûr de vouloir utiliser ce fichier comme modèle " + (isHtml ? "HTML" : "JSON") + " ?<br/>[" + id + "] " + title,
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: "Oui",
                        cancelButtonText: "Non",
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: 'Modification du modèle en cours...',
                                didOpen: () => { Swal.showLoading() }
                            });
                            var req = { id: id, targetId: repId, isPermanent: !isHtml };
                            commonFunc.postMethod("../api/report/SetReportFileDefault", req).then((response) => {
                                var data = response.data;
                                Swal.close();
                                if (data && data.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: "Succès",
                                        html: "Modification effectuée avec succès.",
                                        didOpen: () => { Swal.hideLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    }).then((result) => {
                                        loadFiles();
                                    });
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de la modification du modèle :<br>" + data.errorMessage
                                    });
                                }
                            });
                        }
                    });

                }
            }
        }
    }


    function fileAudioSum({ sysEvent, props, triggerEvent, data }) {
        var file = props;

        var filesDOM = document.querySelectorAll("." + globalProps.className + " .file.selected");
        var cptf = filesDOM.length;

        if (cptf === 1) {

            var id = file.idFile || 0;
            var title = commonFunc.cellFormatterFileType(file.name);
            hideAllMenu();
            if (id > 0) {

                Swal.fire({
                    icon: "question",
                    title: "Transcription",
                    html: "Etes-vous sûr de vouloir générer une transcription pour ce fichier ?<br/>[" + id + "] " + title,
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: "Oui",
                    cancelButtonText: "Non",
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: 'Transcription en cours...',
                            didOpen: () => { Swal.showLoading() }
                        });


                        var req = { fileID: id, fileTypeID: parseInt(file.fileTypeID), bindID: parseInt(file.bindID), bindType: globalProps.fileTypeID, isPermanent:true, OpName: "TRANSCRIPTION_" + globalProps.fileTypeID + "FILE" };
                        if (req.fileID && req.bindID) {
                            var url = "../api/" + globalProps.fileTypeID + "/CreateAudioFileSummary";
                            commonFunc.postMethod(url, req).then(response => {
                                var data = response.data;
                                Swal.close();
                                if (data && data.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: "Transcription proposée [" + data.comments + "]",
                                        html: "<div class='text-start'>" + data.result + "</div>",
                                        didOpen: () => { Swal.hideLoading() },
                                        width: "800px",
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    });
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de création :<br>" + data.errorMessage
                                    });
                                }
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: "Echec de création : Arguments invalides"
                            });
                        }
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Erreur",
                    html: "Aucun Fichier de sélectionné"
                });
            }
        } else {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                html: "Impossible créer un lien pour plusieurs fichiers"
            });
        }
    }

    function fileSum({ sysEvent, props, triggerEvent, data }) {
        var file = props;

        var filesDOM = document.querySelectorAll("." + globalProps.className + " .file.selected");
        var cptf = filesDOM.length;

        if (cptf === 1) {

            var id = file.idFile || 0;
            var title = commonFunc.cellFormatterFileType(file.name);
            hideAllMenu();
            if (id > 0) {

                Swal.fire({
                    icon: "question",
                    title: "Résumé",
                    html: "Etes-vous sûr de vouloir générer un résumé pour ce fichier ?<br/>[" + id + "] " + title,
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: "Oui",
                    cancelButtonText: "Non",
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: 'Création du résumé IA en cours...',
                            didOpen: () => { Swal.showLoading() }
                        });


                        var req = { fileID: id, fileTypeID: parseInt(file.fileTypeID), bindID: parseInt(file.bindID), bindType: globalProps.fileTypeID, OpName: "CREATESAS_" + globalProps.fileTypeID + "FILE" };
                        if (req.fileID && req.bindID) {
                            var url = "../api/" + globalProps.fileTypeID + "/CreateFileSummary";
                            commonFunc.postMethod(url, req).then(response => {
                                var data = response.data;
                                Swal.close();
                                if (data && data.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: "Résumé proposé [" + data.comments +"]",
                                        html: "<div class='text-start'>" + data.result +"</div>",
                                        didOpen: () => { Swal.hideLoading() },
                                        width: "800px",
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    });
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de création :<br>" + data.errorMessage
                                    });
                                }
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: "Echec de création : Arguments invalides"
                            });
                        }
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Erreur",
                    html: "Aucun Fichier de sélectionné"
                });
            }
        } else {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                html: "Impossible créer un lien pour plusieurs fichiers"
            });
        }
    }


    function dlgFileUpload(isCategGroupment, groupment) {
        if (modalRoot) {
            modalRoot.unmount();
            modalRoot = null;
        }

        //Traitement des informations retourné par le Dialog
        var callbackModal = function (modalFiles) {
            console.debug(modalFiles);

            //setFiles(modalFiles);

            if (globalProps.files) {
                var newFiles = globalProps.files;
                modalFiles.forEach(file => {
                    console.debug(file);
                    var tempID = parseInt(Math.floor(Date.now() + Math.random() * 1000000000000001).toString().substring(6));
                    if (globalProps.noUploads) newFiles.push({ idFile: tempID, name: file.name, instanceFile: file, dSysMod: file.lastModifiedDate, prefix: file.docType, length: file.size, categ: file.docType });
                    else if (file.responseData) newFiles.push(file.responseData.result);
                });
                if (globalProps.setFiles) globalProps.setFiles(newFiles);
            }
            if (globalProps.resetAfterUpload) globalProps.files.length = 0;
            else loadFiles();
            

            modalRoot.unmount();
        };

        var supArgs = groupment ? { groupmentFilter: { filter: groupment, type: isCategGroupment ? "categ" : "none" } } : {};

        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<FileUploadModal parentProps={globalProps} title={globalProps.customTitle || ("Transfert de Fichiers " + (globalProps.srcName || ""))} defaultFileType={globalProps.defaultFileType} fileTypeID={globalProps.fileTypeID} bindID={globalProps.bindID}
            waitForCompletion={globalProps.waitForCompletion} {...supArgs} callback={callbackModal}></FileUploadModal>);
    }

    /*function cloneCanvas(oldCanvas) {

        //create a new canvas
        var newCanvas = document.createElement('canvas');
        var context = newCanvas.getContext('2d');

        //set dimensions
        newCanvas.width = oldCanvas.width;
        newCanvas.height = oldCanvas.height;

        //apply the old canvas to the new one
        context.drawImage(oldCanvas, 0, 0);

        //return the new canvas
        return newCanvas;
    }*/

    function searchFiles(e) {
        var currElem = document.querySelector("#filesearch");
        var search = e ? e.target.value : (currElem ? currElem.value : "");

        var allFiles = document.querySelectorAll("#aupdActFilesLst .file");
        allFiles.forEach(function (elem) {
            elem.classList.remove("selected");
        });
        var searchFiles;
        if (search === '*') {
            searchFiles = document.querySelectorAll("#aupdActFilesLst .file-box:not(.hidden) .file");
            searchFiles.forEach(function (elem) {
                elem.classList.add("selected");
            });
        }
        else {
            searchFiles = document.querySelectorAll("#aupdActFilesLst .file-box:not(.hidden) .file-name[title*='" + search + "']");
            searchFiles.forEach(function (elem) {
                elem.parentNode.parentNode.classList.add("selected");
            });
        }
    }

    function fileControl(e) {
        var activeElem = document.querySelector(".file-manager .file-control.active");
        var filterf = activeElem ? activeElem.getAttribute("data-typef") : "*";
        if (e) {
            e.preventDefault();
            var targetElem = e.target;
            if (!targetElem.classList.contains("file-control")) targetElem = targetElem.parentNode;
            filterf = targetElem.getAttribute("data-typef");
        }
        setFilterType(filterf);
    }
    function folderControl(e) {
        var activeElem = document.querySelector(".folder-list li.active");
        var filterc = activeElem ? activeElem.getAttribute("data-tag") : "*";
        if (e) {
            e.preventDefault();
            filterc = e.target.parentNode.getAttribute("data-tag");
        }
        setFolderType(filterc);
    }

    function getExtMenu(file) {
        return globalProps.noContextMenu ? "" : <DropdownMenu>
            {(globalProps.listRendering || globalProps.tableRendering) ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFDl" }) ? "d-none" : ""}`} data="aupdActFDl" onClick={() => { fileDownload({ props: file, data: "aupdActFDl" }) }}>
                <i className="fa fa-download" aria-hidden="true"></i>&nbsp;Télécharger
            </DropdownItem> : ""}
            {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFSas" }) ? "d-none" : ""}`} data="aupdActFSas" onClick={() => { fileSas({ props: file, data: "aupdActFSas" }) }}>
                <i className="fa fa-link" aria-hidden="true"></i>&nbsp;Créer un lien public
            </DropdownItem> : ""}
            {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFSum" }) ? "d-none" : ""}`} data="aupdActFSum" onClick={() => { fileSum({ props: file, data: "aupdActFSum" }) }}>
                <i className="fa fa-quote-right" aria-hidden="true"></i>&nbsp;Créer un résumé (IA)
            </DropdownItem> : ""}

            {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFAudioSum" }) ? "d-none" : ""}`} data="aupdActFAudioSum" onClick={() => { fileAudioSum({ props: file, data: "aupdActFAudioSum" }) }}>
                <i className="fa fa-quote-right" aria-hidden="true"></i>&nbsp;Créer une transcription Audio (IA)
            </DropdownItem> : ""}

            {globalProps.checkRights(globalProps.rightType, "D") ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFDel" }) ? "d-none" : ""}`} data="aupdActFDel" onClick={() => { fileDel({ props: file, data: "aupdActFDel" }) }}>
                <i className="fa fa-times" aria-hidden="true"></i>&nbsp;Supprimer
            </DropdownItem> : ""}
            {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFRes" }) ? "d-none" : ""}`} data="aupdActFRes" onClick={() => { fileRes({ props: file, data: "aupdActFRes" }) }}>
                <i className="fa fa-tasks" aria-hidden="true"></i>&nbsp;Restaurer
            </DropdownItem> : ""}
            <DropdownItem divider />
            {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFDefault" }) ? "d-none" : ""}`} data="aupdActFDefault" onClick={() => { fileDefComplete({ props: file, data: "aupdActFDefault" }) }}>
                <i className="fa fa-check-circle" aria-hidden="true"></i>&nbsp;Marquer comme Rapport Complété
            </DropdownItem> : ""}
            {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFRpiDef" }) ? "d-none" : ""}`} data="aupdActFRpiDef" onClick={() => { fileDefFinal({ props: file, data: "aupdActFRpiDef" }) }}>
                <i className="fa fa-tasks" aria-hidden="true"></i>&nbsp;Définir comme Rapport Final
            </DropdownItem> : ""}
            {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFRpiReplay" }) ? "d-none" : ""}`} data="aupdActFRpiReplay" onClick={() => { fileReplay({ props: file, data: "aupdActFRpiReplay" }) }}>
                <i className="fa fa-history " aria-hidden="true"></i>&nbsp;Rejouer les evénements
            </DropdownItem> : ""}
            <DropdownItem divider />
            {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFModRpt" }) ? "d-none" : ""}`} data="aupdActFModRpt" onClick={() => { fileModel({ props: file, data: "aupdActFModRpt" }) }}>
                <i className="fa fa-tasks " aria-hidden="true"></i>&nbsp;Définir comme modèle de rapport
            </DropdownItem> : ""}
            {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <DropdownItem className={`${isItemHidden({ props: file, data: "aupdActFModHtml" }) ? "d-none" : ""}`} data="aupdActFModHtml" onClick={() => { fileModel({ props: file, data: "aupdActFModHtml" }) }}>
                <i className="fa fa-tasks " aria-hidden="true"></i>&nbsp;Définir comme modèle d’aperçu HTML
            </DropdownItem> : ""}
        </DropdownMenu>;
    }

    var filteredFiles = files.filter((file) => {
        return !file.props || (((filterType === "*" && file.props["data-typef"] !== "sys") || file.props["data-typef"] === filterType) && (folderType === "*" || file.props["data-typec"] === folderType));
    });

    //PATCH : préviens les erreurs lors de changement de rendering + le cas groupRender
    if (!globalProps.tableRendering && filteredFiles?.length && !(filteredFiles[0].props || (Array.isArray(filteredFiles[filteredFiles?.length - 1]) && filteredFiles[filteredFiles?.length - 1][0].props))) filteredFiles = [];
    
    //console.debug("renderFCustom");

    var dropzoneContent = "";
    if (globalProps.withDropzone) {
        //Traitement des informations retourné par le Dialog
        var callbackModal = function (modalFiles) {
            console.debug(modalFiles);

            //setFiles(modalFiles);

            if (globalProps.files) {
                var newFiles = globalProps.files;
                modalFiles.forEach(file => {
                    console.debug(file);
                    var tempID = parseInt(Math.floor(Date.now() + Math.random() * 1000000000000001).toString().substring(6));
                    if (globalProps.noUploads) newFiles.push({ idFile: tempID, name: file.name, instanceFile: file, dSysMod: file.lastModifiedDate, prefix: file.docType, length: file.size, categ: file.docType });
                    else if (file.responseData) newFiles.push(file.responseData.result);
                });
                if (globalProps.setFiles) globalProps.setFiles(newFiles);
            }
            if (globalProps.resetAfterUpload) globalProps.files.length = 0;
            else loadFiles();
        };


        dropzoneContent = <FileUploadModal parentProps={globalProps} title={globalProps.customTitle || ("Transfert de Fichiers " + (globalProps.srcName || ""))} defaultFileType={globalProps.defaultFileType} fileTypeID={globalProps.fileTypeID} bindID={globalProps.bindID}
            waitForCompletion={globalProps.waitForCompletion} noModal callback={callbackModal}></FileUploadModal>;
    }

    var localFilesType = filesType;
    if (globalProps.notSyncableFilesType) localFilesType = localFilesType.filter(type => !type.isSyncable);
    if (globalProps.excludedFilesTypes) localFilesType = localFilesType.filter(type => globalProps.excludedFilesTypes.indexOf(type.refExtID) < 0);


    if (globalProps.badgeRendering) {
        return <Row className={globalProps.className}>
            {dropzoneContent}
            <div>
                <div className={`cfiles-container pb-3 ${globalProps.placeHolder ? "position-relative" : ""}`}>
                    {globalProps.placeHolder || ""}
                    <div className="">
                        {!globalProps.noUploadBtn && globalProps.checkRights(globalProps.rightType, "C") ? <Button id="btnActFilesUpload" className={`btn-magnify px-2 my-0 ${globalProps.disabled ? "disabled" : ""}`} color={btnAddFilesColor} size="sm" onClick={() => { dlgFileUpload() }}><i className={`fa ${btnAddFilesIcon}`}></i> {btnAddFilesLabel}</Button> : ""}

                        <div className="hr-line-dashed"></div>
                    </div>

                    <div id="aupdActFilesLst" className="row px-2">
                        {filteredFiles}
                    </div>
                </div>
            </div>
        </Row>;
    }
    else if (globalProps.listRendering) {
        return <div className={globalProps.className}>
            {dropzoneContent}
            <div className={`cfiles-container ${globalProps.placeHolder ? "position-relative" : ""}`}>
                {globalProps.placeHolder || ""}
                <div className="">
                    {!globalProps.noUploadBtn && globalProps.checkRights(globalProps.rightType, "C") ? <Button id="btnActFilesUpload" className={`btn-magnify px-2 my-0 ${globalProps.disabled ? "disabled" : ""}`} color={btnAddFilesColor} size="sm" onClick={() => { dlgFileUpload() }}><i className={`fa ${btnAddFilesIcon}`}></i> {btnAddFilesLabel}</Button> : ""}
                </div>

                <div className={`d-flex align-items-center p-2 m-0 text-secondary fw-bold`} style={{ fontSize: "11px" }}>
                    <div style={{ flex: "auto" }}>DOCUMENT</div>
                    <div style={{ width: "70px" }}>TAILLE</div>
                    <div style={{ width: "140px" }}>MODIFIÉ</div>
                    <div>CATÉGORIE</div>
                </div>
                <div className="hr-line-solid mt-0" style={{ borderColor: "#19253d33" }}></div>

                <div id="aupdActFilesLst" className="">
                    {filteredFiles}
                </div>
            </div>
        </div>;
    }
    else if (globalProps.tableRendering) {
        var dataStamp = JSON.stringify(filteredFiles.map(file => file.idFile));
        var dtFunctions = {};
        var functionPanel = (id, fctPanel) => {
            if (!dtFunctions) dtFunctions = {};
            if (!dtFunctions[id]) dtFunctions[id] = {};
            dtFunctions[id] = fctPanel;
        };

        var dtConfig = {
            dtOnSelect: function (dataSel) {
                if (globalProps.onFileClick && typeof (globalProps.onFileClick) === "function") { globalProps.onFileClick(dataSel, null); }
            },
            dtOnUnselect: function (dataSel) {
                if (globalProps.onFileClick && typeof (globalProps.onFileClick) === "function") { globalProps.onFileClick(null, null); }
            },
            dtOnDblClick: function (e, rowTable) {
                //var dataSel = e.target;
                var dataSel = rowTable.data();
                if (globalProps.onFileDblClick && typeof (globalProps.onFileDblClick) === "function") { globalProps.onFileDblClick(dataSel, null); }
            }
        };

        //this.dtFunctionPanel.bind(this)
        return <div className={globalProps.className}>
            {dropzoneContent}
            <div className={`cfiles-container ${globalProps.placeHolder ? "position-relative" : ""}`}>
                {globalProps.placeHolder || ""}
                <div className="">
                    {!globalProps.noUploadBtn && globalProps.checkRights(globalProps.rightType, "C") ? <Button id="btnActFilesUpload" className={`btn-magnify px-2 my-0 ${globalProps.disabled ? "disabled" : ""}`} color={btnAddFilesColor} size="sm" onClick={() => { dlgFileUpload() }}><i className={`fa ${btnAddFilesIcon}`}></i> {btnAddFilesLabel}</Button> : ""}

                    <div className="hr-line-dashed"></div>
                </div>
                <CDataTable key="files" dtId={"aupdActFilesLst"} data={filteredFiles} localConfig={dtConfig} tag={"DT_FILES"} config={globalProps.models["DT_FILES"]} stamp={dataStamp} selectEvent={(id) => { /*this.showDetails(id)*/ }} functionPanel={functionPanel}
                    className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} attrSup={{ "dt-filter-target": ("aupdActFilesLst_filters") }} />
            </div>
        </div>;
    }
    else if (globalProps.altRendering || globalProps.renderMode === "groupcard-md" || globalProps.renderMode === "card-md") {
        return <div className={globalProps.className}>
            {dropzoneContent}
            <div className={`cfiles-container pb-3 ${globalProps.placeHolder ? "position-relative" : ""}`}>
                {globalProps.placeHolder || ""}

                <div id="aupdActFilesLst" className="">
                    {filteredFiles}
                    {!globalProps.noUploadBtn && globalProps.checkRights(globalProps.rightType, "C") ?
                        <Button id="btnActFilesUpload" className={`btn-simple btn-magnify float-start px-2 my-0 mb-3 ${globalProps.disabled ? "disabled" : ""}`} color="secondary"
                            style={{ height: "60px", minWidth: "60px", borderStyle: "dashed" }} onClick={() => { dlgFileUpload() }}><i className="fa fa-plus-circle mb-1 d-block"></i>Ajouter</Button>
                        : ""}
                </div>
            </div>
        </div>;
    }
    else if (globalProps.onlyUpload) {
        return <Button id="btnActFilesUpload" className="btn-magnify px-2 my-0" color={btnAddFilesColor} size="sm" onClick={() => { dlgFileUpload() }}><i className={`fa ${btnAddFilesIcon}`}></i> {btnAddFilesLabel}</Button>;
    }
    else {
        return (<><Row className={globalProps.className}>
            <Col className={globalProps.withFilters ? "" : "d-none"} md="4" lg="3">
                <Card className="widget dash">
                    <CardHeader>
                        <CardTitle tag="h6">VISUALISER</CardTitle>
                        <div className="widget-tools collapse-tool">
                            <i className="fa fa-filter fa-4x"></i>
                        </div>
                        <div className='borderTheme'></div>
                    </CardHeader>
                    <CardBody>
                        <div className="file-manager files-container mt-1">
                            <h5>Rechercher</h5>
                            <InputGroup>
                                <InputGroupText>
                                    <i aria-hidden="true" className="fa fa-magnifying-glass"></i>
                                </InputGroupText>
                                <Input type="text" autoComplete="off" aria-autocomplete="none" className="form-control input-icon" name="file-search" id="filesearch" onInput={(e) => searchFiles(e)} />
                            </InputGroup>
                            <div className="hr-line-dashed"></div>
                            <h5>Afficher:</h5>
                            <a className={filterType === "*" ? "file-control active" : "file-control"} href="#" data-typef='*' onClick={(e) => fileControl(e)}>Tout</a>
                            <a className={filterType === "doc" ? "file-control active" : "file-control"} href="#" data-typef='doc' onClick={(e) => fileControl(e)}>Documents</a>
                            <a className={filterType === "aud" ? "file-control active" : "file-control"} href="#" data-typef='aud' onClick={(e) => fileControl(e)}>Audio</a>
                            <a className={filterType === "img" ? "file-control active" : "file-control"} href="#" data-typef='img' onClick={(e) => fileControl(e)}>Images</a>
                            <a className={filterType === "vid" ? "file-control active" : "file-control"} href="#" data-typef='vid' onClick={(e) => fileControl(e)}>Vidéos</a>
                            <a className={filterType === "sys" ? "file-control active" : "file-control"} href="#" data-typef='sys' onClick={(e) => fileControl(e)}><i className="fa fa-cog" aria-hidden="true"></i></a>
                            <div className="hr-line-dashed"></div>

                            <h5>Catégories</h5>
                            <ul className="folder-list p-0">
                                {(() => {
                                    var noneElem = <li data-bindid='0' data-tag='*' className={folderType === "*" ? "active" : ""}><a href='#' onClick={(e) => folderControl(e)}><i className='fa fa-folder'></i>&nbsp;Toutes</a></li>;
                                    var filters = localFilesType.map((type, index) => {
                                        var sup = "";
                                        if (type.idFileType > 0) {
                                            return <li key={index} data-bindid={type.idFileType} data-tag={type.refExtID} className={folderType === type.refExtID ? "active" : ""}><a href='#' onClick={(e) => folderControl(e)}><i className='fa fa-folder'></i>&nbsp;{type.name}</a></li>;
                                        }
                                        return "";
                                    });
                                    return <>{noneElem}{filters}</>;
                                })()}
                            </ul>
                            <div className="clearfix"></div>
                        </div>
                    </CardBody>
                    <CardFooter>
                    </CardFooter>
                </Card>
            </Col>
            <Col md={globalProps.withFilters ? "5" : "12"} lg={globalProps.withFilters ? "9" : "12"} className="h-100">
                <Card className="widget dash">
                    <CardHeader>
                        <CardTitle tag="h6">{globalProps.title ? globalProps.title : "FICHIERS"}</CardTitle>
                        <div className="widget-tools collapse-tool">
                            <i className="fa fa-copy fa-4x"></i>
                        </div>
                        <div className='borderTheme'></div>
                    </CardHeader>
                    <CardBody>
                        <div>
                            <div className="files-container pb-3">
                                <div className="">
                                    {!globalProps.hideSync ? <Button id="btnActFilesRefresh" className="btn-rotate px-2 my-0 btn-simple" color="dark" size="sm" onClick={() => loadFiles()}>
                                        <i className="fa fa-sync"></i>Actualiser
                                    </Button> : ""}
                                    {globalProps.checkRights(globalProps.rightType, "C") ? <Button id="btnActFilesUpload" className="btn-magnify px-2 my-0" color={btnAddFilesColor} size="sm" onClick={() => { dlgFileUpload() }}><i className={`fa ${btnAddFilesIcon}`}></i> {btnAddFilesLabel}</Button> : ""}

                                    <div className="hr-line-dashed"></div>
                                </div>

                                <div id="aupdActFilesLst" className="">
                                    {filteredFiles}
                                </div>
                            </div>
                        </div>
                    </CardBody>
                    <CardFooter>
                        <div className="float-end">
                            <span id="aupdActFilesCount" className="badge bg-primary me-1">{totFiles} Fichier(s)</span>
                            <span id="aupdActFilesSize" className="badge bg-info me-1">{commonFunc.bytesToSize(totLength, 1)}</span>
                        </div>
                    </CardFooter>
                </Card>
            </Col>
        </Row>
            {globalProps.noContextMenu ? "" : <Menu id="contextMenu" onVisibilityChange={() => {/*console.debug(document.querySelector(".contexify") ? document.querySelector(".contexify").outerHTML : "")*/ }}>
                {(globalProps.listRendering || globalProps.tableRendering) ? <Item hidden={isItemHidden.bind(this)} data="aupdActFDl" onClick={fileDownload.bind(this)}>
                    <i className="fa fa-download" aria-hidden="true"></i>&nbsp;Télécharger
                </Item> : ""}

                {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <Item hidden={isItemHidden.bind(this)} data="aupdActFSas" onClick={fileSas.bind(this)}>
                    <i className="fa fa-link" aria-hidden="true"></i>&nbsp;Créer un lien public
                </Item> : ""}
                {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <Item hidden={isItemHidden.bind(this)} data="aupdActFSum" onClick={fileSum.bind(this)}>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>&nbsp;Créer un résumé (IA)
                </Item> : ""}

                {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <Item hidden={isItemHidden.bind(this)} data="aupdActFAudioSum" onClick={fileAudioSum.bind(this)}>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>&nbsp;Créer une transcription Audio (IA)
                </Item> : ""}

                {globalProps.checkRights(globalProps.rightType, "D") ? <Item hidden={isItemHidden.bind(this)} data="aupdActFDel" onClick={fileDel.bind(this)}>
                    <i className="fa fa-times" aria-hidden="true"></i>&nbsp;Supprimer
                </Item> : ""}
                {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <Item hidden={isItemHidden.bind(this)} data="aupdActFRes" onClick={fileRes.bind(this)}>
                    <i className="fa fa-tasks" aria-hidden="true"></i>&nbsp;Restaurer
                </Item> : ""}
                <Separator />
                {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <Item hidden={isItemHidden.bind(this)} data="aupdActFDefault" onClick={fileDefComplete.bind(this)}>
                    <i className="fa fa-check-circle" aria-hidden="true"></i>&nbsp;Marquer comme Rapport Complété
                </Item> : ""}
                {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <Item hidden={isItemHidden.bind(this)} data="aupdActFRpiDef" onClick={fileDefFinal.bind(this)}>
                    <i className="fa fa-tasks" aria-hidden="true"></i>&nbsp;Définir comme Rapport Final
                </Item> : ""}
                {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <Item hidden={isItemHidden.bind(this)} data="aupdActFRpiReplay" onClick={fileReplay.bind(this)}>
                    <i className="fa fa-history " aria-hidden="true"></i>&nbsp;Rejouer les evénements
                </Item> : ""}
                <Separator />
                {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <Item hidden={isItemHidden.bind(this)} data="aupdActFModRpt" onClick={fileModel.bind(this)}>
                    <i className="fa fa-tasks " aria-hidden="true"></i>&nbsp;Définir comme modèle de rapport
                </Item> : ""}
                {!globalProps.onlyDelete && globalProps.checkRights(globalProps.rightType, "U") ? <Item hidden={isItemHidden.bind(this)} data="aupdActFModHtml" onClick={fileModel.bind(this)}>
                    <i className="fa fa-tasks " aria-hidden="true"></i>&nbsp;Définir comme modèle d’aperçu HTML
                </Item> : ""}
            </Menu>}</>);
    }
};

FilesCustom.propTypes = {
    bindID: PropTypes.number.isRequired,
    fileTypeID: PropTypes.string.isRequired,//number
    shouldRender: PropTypes.bool,
    src: PropTypes.object,
    srcName: PropTypes.string,
    className: PropTypes.string,
    withFilters: PropTypes.bool,
};

const withI18n = (Component) => {
    const Wrapped = (props, ref) => {
        const i18n = useTranslation();
        return (<Component {...props} forwardedRef={ref} i18nManager={{ ...i18n }} />);
    };
    Wrapped.displayName = `withI18n(${Component.displayName || Component.name})`;

    return React.forwardRef(Wrapped);
}


export default withI18n(FilesCustom);


export function ExtUpload(globalProps) {
    var { url, bindID, fileType, fileTypeID, files, setFiles, callback } = globalProps;

    const [progressUpload, setProgressUpload] = React.useState(false);
    //const [timestamp, setTimestamp] = React.useState(true);

    const [controllers, setControllers] = React.useState([]);

    React.useEffect(() => {
        async function fetchData() {
            if (files && files.length) {
                console.debug(files);

                var asyncJobs = [new Promise(resolve => {resolve();})];
                var index = 1;
                //files.forEach(async (file, index) => {
                for (const objFile of files) {
                    var file = objFile.instanceFile;
                    if (file && !file.closed && (controllers.length === 0 || !controllers[0].signal.aborted)) {
                        const formData = new FormData();
                        /*var fileUpReq = {
                            name: "AVA_" + Date.now() + "_" + file.name,
                            ftype: "AVA", //cat Photo
                            fvisible: 1,
                            fcntry: "FR",
                            fbindId: 2, //Type
                            factId: -1,
                        }; */

                        console.debug(file.docType || fileType);
                        var fileUpReq = {
                            name: file.name,
                            ftype: file.docType || fileType || "AUT",
                            bindType: fileTypeID || "",
                            visibility: 1,
                            language: "FR",
                            //fbindId: props.fileTypeID, //Type
                            bindId: bindID || -1,
                            //bindSubId
                            fileTypeID: file.docTypeId || -1,
                            lastModified: file.lastModifiedDate,
                            //useTimestamp: timestamp
                        };
                        fileUpReq.waitForCompletion = (globalProps.waitForCompletion ? globalProps.waitForCompletion(fileUpReq) : false);

                        formData.append('file', file);
                        formData.append('args', JSON.stringify(fileUpReq));


                        const onUploadProgress = (event) => {
                            console.debug(event);

                            file.loaded = event.loaded;
                            file.total = event.total;
                            file.progress = Math.round(100 * event.progress);
                            //setLocalFiles(files);
                            if (setFiles) {
                                setFiles(files.map(el => {
                                    console.debug(el.instanceFile === file);
                                    el.instanceFile = el.instanceFile === file ? file : el.instanceFile;
                                    return el;
                                }));
                            }
                            setProgressUpload(!progressUpload);
                        };

                        const controller = new AbortController();
                        controllers.push(controller);
                        setControllers(controllers);

                        asyncJobs[index] = await axios.post(url || "../api/data/UploadFiles", formData, { signal: controller.signal, headers: { "Content-Type": "multipart/form-data" }, onUploadProgress }).then((response => {
                            file.closed = true;
                            if (response.data.isSuccess) {
                                file.validated = true;
                                file.responseData = response.data;
                            }
                            else {
                                file.error = response.data.errorMessage;
                            }
                            if (setFiles) {
                                setFiles(files.map(el => {
                                    el.instanceFile = el.instanceFile === file ? file : el.instanceFile;
                                    return el;
                                }));
                            }
                            setProgressUpload(!progressUpload);
                            return new Promise(resolve => {
                                resolve(response);
                            });
                        })).catch(error => {
                            return new Promise((resolve) => {
                                resolve({ isSuccess: false, errorMessage: error });
                            });
                        });
                    }
                    index++;
                }

                if (asyncJobs.length) {
                    Promise.all(asyncJobs).then(results => {
                        console.debug(results);
                        setControllers([]);
                        //files.forEach(file => { file.instanceFile = null; });

                        var finalFiles = [];
                        var errors = [];
                        files.forEach((file) => {
                            if (file.instanceFile) {
                                if (file.instanceFile.responseData) {
                                    finalFiles.push(file.instanceFile.responseData.result);
                                }
                                else {
                                    //Error - file.instanceFile.error
                                    errors.push(file.instanceFile);

                                    //file.instanceFile = null;
                                    //finalFiles.push(file);
                                }
                            }
                            //Conservation des fichiers déjà uploads
                            else {
                                //PATCH : conservation name dut au removeTimestamp
                                if (!commonFunc.isBlank(file.orgName)) file.name = file.orgName;
                                file.orgName = null;

                                finalFiles.push(file);
                            }
                        })

                        if (setFiles) setFiles(finalFiles);

                        callback(finalFiles, errors);
                        //setLocalFiles(files);
                        //setProgressUpload(!progressUpload);
                        return;

                    }, rej => {
                        Swal.fire({
                            icon: "error",
                            title: "Erreur",
                            html: "Erreur de l'upload des fichiers :<br>" + rej.message
                        });
                    })
                        .catch(error => {
                            Swal.fire({
                                icon: "error",
                                title: "Erreur",
                                html: "Erreur de l'upload des fichiers :<br>" + error.message
                            });
                        });
                }
            }
            else {
                Swal.fire({
                    icon: "warning",
                    title: "Attention",
                    html: "Aucun fichier à télécharger"
                });
            }
        }
        fetchData();
    }, []);
    

    return <Modal isOpen={true} className="modal-files" size="sm" keyboard={false} backdrop="static" style={{ paddingTop: "0px" }}>
        <ModalHeader className="d-flex"></ModalHeader>
        <ModalBody>Upload des fichiers en cours...</ModalBody>
        <ModalFooter className="px-2 flex-nowrap">
            <Progress className="w-100 float-end" color="success" style={{ height: '15px' }} value={(() => {
                var valueLoaded = 0;
                var valueTotal = 0;
                files.forEach(orgFile => {
                    var file = orgFile.instanceFile;
                    if (file && !file.closed) {
                        valueLoaded += (file.loaded || 0);
                        valueTotal += (file.size || 0);//total avait besoin qu'on passe une fois dans onUploadProgress pour chaque fichier (impossible en sequentiel)
                    }
                });
                return (valueLoaded / valueTotal * 100);
            })()}></Progress>
        </ModalFooter>
    </Modal>;
}


//Création d'un "function component" pour gérer l'affichage du Dialog
//props correspond aux attributs fournies lors de la déclaration de FileUploadModal
export function FileUploadModal(props) {
    //Equivalent à componentDidMount ( OU componentDidUpdate etc... en fonction des paramètres)
    React.useEffect(() => {

        return () => {
            //console.debug("unmount");
            if (localFiles && localFiles.length) {
                localFiles.forEach((e, i) => {
                    URL.revokeObjectURL(e.preview);
                });
            }
        }
    }, []);

    var localFilesType = filesType;
    if (props.parentProps?.notSyncableFilesType) localFilesType = localFilesType.filter(type => !type.isSyncable);
    if (props.parentProps?.excludedFilesTypes) localFilesType = localFilesType.filter(type => props.parentProps.excludedFilesTypes.indexOf(type.refExtID) < 0);
    if (props.groupmentFilter) {
        if (props.groupmentFilter.type === "categ") localFilesType = localFilesType.filter(type => type.refExtID.replace(/\d$/, "") === props.groupmentFilter.filter);
        else localFilesType = localFilesType.filter(type => type.refExtID.slice(-1) === props.groupmentFilter.filter);
    }



    //Gestion de données utile au Dialog
    //const [rerender, setRerender] = React.useState(false);
    const [fileType, setFileType] = React.useState(() => {
        if (localFilesType.length && !props.parentProps.noChooseTypes) {
            var defaultFT = localFilesType.find(t => t.refExtID === props.defaultFileType);
            if (!defaultFT) return localFilesType[0].refExtID;
        }
        return props.defaultFileType || "";
    });
    //const [fileTypeId, setFileTypeId] = React.useState(0);
    //const [fileTypeId, setFileTypeId] = React.useState((filesType && props.defaultFileType) ? (filesType.filter(type => type.refExtID === props.defaultFileType)[0].idFileType) : 0);
    const [fileTypeId, setFileTypeId] = React.useState((localFilesType && props.defaultFileType) ? () => {
        var typesFiltered = localFilesType.filter(type => type.refExtID === props.defaultFileType);
        if (typesFiltered.length) {
            return typesFiltered[0].idFileType || 0;
        }
        else {
            return 0;
        }
    } : 0);
    const [localFiles, setLocalFiles] = React.useState(props.files || []);
    const [progressUpload, setProgressUpload] = React.useState(false);
    const [processing, setProcessing] = React.useState(false);
    const [timestamp, setTimestamp] = React.useState(props.parentProps?.defaultTimestamp === false ? false : true);

    const [controllers, setControllers] = React.useState([]);

    async function uploadFiles() {
        var files = localFiles;
        if (files && files.length) {
            console.debug(files);

            if (!props.parentProps?.minFiles || props.parentProps?.minFiles <= files.length) {

                var asyncJobs = [];
                var index = 0;
                //files.forEach(async (file, index) => {
                for (const file of files) {
                    if (!file.closed && (controllers.length === 0 || !controllers[0].signal.aborted)) {
                        const formData = new FormData();
                        /*var fileUpReq = {
                            name: "AVA_" + Date.now() + "_" + file.name,
                            ftype: "AVA", //cat Photo
                            fvisible: 1,
                            fcntry: "FR",
                            fbindId: 2, //Type
                            factId: -1,
                        }; */
                        console.debug(file.docType || fileType);
                        var fileUpReq = {
                            name: file.name,
                            ftype: file.docType || fileType || "AUT",
                            bindType: props.fileTypeID || "",
                            visibility: 1,
                            language: "FR",
                            //fbindId: props.fileTypeID, //Type
                            bindId: props.bindID || -1,
                            //bindSubId
                            fileTypeID: file.docTypeId || -1,
                            lastModified: file.lastModifiedDate,
                            useTimestamp: timestamp
                        };
                        fileUpReq.waitForCompletion = (props.waitForCompletion ? props.waitForCompletion(fileUpReq) : false);

                        if (props.parentProps?.customPath) fileUpReq.additionalPath = props.parentProps.customPath;

                        formData.append('file', file);
                        formData.append('args', JSON.stringify(fileUpReq));


                        const onUploadProgress = (event) => {
                            console.debug(event);

                            file.loaded = event.loaded;
                            file.total = event.total;
                            file.progress = Math.round(100 * event.progress);
                            //setLocalFiles(files);
                            setLocalFiles(files.map(el => {
                                return (el === file ? file : el)
                            }));
                            setProgressUpload(!progressUpload);
                            /*let progressBarElement = document.getElementById("progress-bar");
                            progressBarElement.innerHTML = percentage + "%";
                            progressBarElement.setAttribute("aria-valuenow", percentage);
                            progressBarElement.style.width = percentage + "%"; */
                        };
                        setProcessing(true);

                        const controller = new AbortController();
                        controllers.push(controller);
                        setControllers(controllers);

                        asyncJobs[index] = await axios.post(props.parentProps.altUploadFilesUrl || "../api/data/UploadFiles", formData, { signal: controller.signal, headers: { "Content-Type": "multipart/form-data", }, onUploadProgress }).then((response => {
                            file.closed = true;
                            if (response.data.errorI18n === "UPLOAD_400") {
                                file.error = props.parentProps?.i18nManager?.t("errors." + response.data.errorI18n);
                            }
                            else if (response.data.isSuccess) {
                                file.validated = true;
                                file.responseData = response.data;
                            }
                            else {
                                file.error = response.data.errorMessage;
                            }
                            setLocalFiles(files.map(el => {
                                return (el === file ? file : el)
                            }));
                            setProgressUpload(!progressUpload);
                            return new Promise(resolve => {
                                resolve(response);
                            });
                        })).catch(error => {
                            return new Promise((resolve) => {
                                resolve({ isSuccess: false, errorMessage: error });
                            });
                        });
                    }
                    index++;
                }

                if (asyncJobs.length) {
                    Promise.all(asyncJobs).then(results => {
                        console.debug(results);
                        setProcessing(false);
                        setControllers([]);
                        files.forEach(file => {
                            file.progress = 0;
                            file.loaded = 0;
                            file.total = 0;
                        });
                        if (!props.noModal) {
                            setLocalFiles(files);
                            if (props.parentProps?.uploadAutoClose) props.callback(files);
                        }
                        else {
                            //setLocalFiles([]);
                            setLocalFiles(files);
                            props.callback(files);
                        }


                        //setLocalFiles(files);
                        //setProgressUpload(!progressUpload);
                        return;

                    }, rej => {
                        setProcessing(false);
                        Swal.fire({
                            icon: "error",
                            title: "Erreur",
                            html: "Erreur de l'upload des fichiers :<br>" + rej.message
                        });
                    })
                        .catch(error => {
                            setProcessing(false);
                            Swal.fire({
                                icon: "error",
                                title: "Erreur",
                                html: "Erreur de l'upload des fichiers :<br>" + error.message
                            });
                        });
                }
            }
            else {
                Swal.fire({
                    icon: "warning",
                    title: "Attention",
                    html: "Fichiers insuffisant : (" + files.length + "/" + props.parentProps?.minFiles + ")"
                });
            }
        }
        else {
            Swal.fire({
                icon: "warning",
                title: "Attention",
                html: "Aucun fichier à télécharger"
            });
        }
    }

    function cancelUpload() {
        console.debug("Abort Requests");
        controllers.forEach((controller) => {
            controller.abort();
        });
        setControllers([]);
    }

    //console.debug("render modal");

    var uploadTypes = props.accept || props.parentProps.accept || {};
    /* /(\.|\/)(gif|jpe?g|png|avi|mp4)$/i */
    /*{
        'image/*': [".png", ".gif", ".jpeg", ".jpg"],
        'text/html': ['.html', '.htm'],
    }*/

    var chooseTypeContent = <>
        <label className="text-start control-label fw-bold ms-3">Type de Doc :</label>
        <Input className="w-auto d-inline-block mx-1 me-auto" name="categorie" type="select"
            defaultValue={fileType} onChange={(e) => {
                var value = e.target.value;
                var option = e.target.querySelector("option[value='" + value + "']");
                setFileType(value);
                setFileTypeId(parseInt(option.getAttribute("data-id")) || 0);
            }}>
            {localFilesType.map((dt, index) => {
                if (dt.refExtID === "DIR") return "";
                else return (<option key={index} data-id={dt.idFileType} value={dt.refExtID}>{dt.name}</option>);
            })}
        </Input>
    </>;


    var content = <Row className={`m-0 ${props.noModal ? "p-0" : "px-1"}`}>
        <Col lg="12" className={`${props.noModal ? "p-0" : ""}`}>
            <Dropzone accept={uploadTypes}
                maxFiles={props.parentProps.maxFiles || 0}
                maxSize={props.parentProps.maxSize}//14990000//Infinity
                noClick={false}
                noKeyboard
                noDragEventsBubbling
                preventDropOnDocument={false}
                onDrop={(acceptedFiles, fileRejections, e) => {
                    if (e) e.target.classList.remove("hover");

                    acceptedFiles.forEach((file) => {
                        const reader = new FileReader()

                        reader.onabort = () => console.log('file reading was aborted')
                        reader.onerror = () => console.log('file reading has failed')
                        reader.onload = () => {
                            // Do whatever you want with the file contents
                            const binaryStr = reader.result
                            console.log(binaryStr)
                        }
                        reader.readAsArrayBuffer(file)
                    });

                    if (fileRejections && fileRejections.length) {
                        Swal.fire({
                            icon: "warning",
                            title: "Attention",
                            html: "Certains fichiers ne peuvent pas être uploadé :<br/>" + fileRejections.map(file => "<div title='" + file.errors.map(error => error.message.replace("Too many files", "Trop de fichiers").replace("File is larger than", "Fichiers trop volumineux : ").replace("bytes", "octets max") + "\n") + "'>" + file.file.name + "<i class='fa fa-2xs fa-circle-info'></i></div>")
                        });
                    }

                    var newFiles = acceptedFiles.map(file => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        docType: file.docType || fileType,
                        docTypeId: file.docTypeId || fileTypeId,
                    }));
                    if (!props.parentProps.maxFiles || (((localFiles?.length || 0) + (newFiles?.length || 0)) <= props.parentProps.maxFiles)) {
                        newFiles = newFiles.concat(localFiles);
                        setLocalFiles(newFiles);
                        //setRerender(!rerender);
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Nombre de fichiers maximum dépassé"
                        });
                    }
                }}
                onDragEnter={(e) => {
                    e.target.classList.add("hover");
                }}
                onDragLeave={(e) => {
                    e.target.classList.remove("hover");
                }}
            >
                {({ acceptedFiles, getRootProps, getInputProps, open, rootRef, inputRef, isFocused }) => {

                    var filesContent = <>{
                        localFiles.length ? localFiles.map((file, index) => {

                            /*<div className="thumb" key={file.name}>
                                <div className="thumbInner">
                                    <img alt=""
                                        src={file.preview}
                                        className="thumbImg"
                                        // Revoke data uri after image is loaded (/!\ Empêche la récupération des images si fermeture du modal)
                                        onLoad={() => { URL.revokeObjectURL(file.preview) }}
                                    />
                                </div>
                            </div>*/
                            console.debug(file.preview);
                            var dateM = commonFunc.formatDateTime(new Date(file.lastModified));//Patch 28/06/2018

                            var currFileType = file.docType || fileType;
                            var tempId = "ftmp-" + index;
                            return (<div key={index} id={tempId} className={`file-box ${props.noModal ? "small" : "medium"} ${file.validated ? "upload-valid" : (file.error ? "upload-error" : "")} ${file.closed ? "file-closed" : "file-open"}`} onClick={(e) => {
                                e.preventDefault();
                                var fileElem = document.querySelector(".modal-files #" + tempId + " .file");
                                var allFiles = fileElem?.parentNode?.parentNode?.querySelectorAll(".modal-files .file");
                                allFiles?.forEach(function (elem) {
                                    elem.classList.remove("selected");
                                });
                                fileElem?.classList.add("selected");
                            }}>
                                <div className='file'>
                                    <a href='#'>
                                        <span className='corner'></span>
                                        <div className='preview'>
                                            <Img alt="" draggable="false"
                                                src={file.preview}
                                                className="thumbImg" />
                                            <br />{commonFunc.getFilesFaIcon(file.name, currFileType)}
                                            {props.parentProps.noUploads ? "" : <div className='float-end me-2' style={{ width: 40, height: 40 }}>
                                                <CircularProgressbarWithChildren value={(!file.validated && !file.error) ? (file.progress || 0) : 100} text={(!file.validated && !file.error) ? ((file.progress || 0) + "%") : ""}
                                                    styles={{ path: { stroke: ((!file.validated && !file.error) ? `rgba(62, 152, 199, ${file.progress / 100})` : (file.validated ? "#6bd098" : "#dc3545")) } }}>
                                                    {file.validated ? <i className="fa fa-check fw-bold text-success" style={{ fontSize: "18px" }}></i> : ""}
                                                    {file.error ? <i className="fa fa-times fw-bold text-danger" style={{ fontSize: "18px" }}></i> : ""}
                                                </CircularProgressbarWithChildren>
                                            </div>}
                                            {(!file.validated || props.noModal) ? <button type='button' className={`btn btn-link btn-icon float-end m-0 ${processing ? "invisible" : ""}`} onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                var newList = localFiles.filter(function (e, i) {
                                                    var flag = i !== index;
                                                    if (!flag) file = e;
                                                    return flag;
                                                });
                                                if (file) URL.revokeObjectURL(file.preview);
                                                setLocalFiles(newList);
                                            }}>
                                                <i className='fa fa-trash-alt' style={{ fontSize: "24px" }}></i>
                                            </button> : ""}
                                        </div>
                                        <div className='file-name'>{file.name}<br /><small className='float-start'>{dateM}</small><small className='float-end'>{commonFunc.bytesToSize(file.size, 1)}</small></div>
                                        <div className='side-corner-tag alt-filetype' data-typec={currFileType}><div><span>{currFileType}</span></div></div>
                                    </a>
                                </div>
                                <p className={`text-danger ${file.error ? "" : "d-none"}`}>{file.error}</p>
                            </div>);
                        }) : ""
                    }</>;

                    var actionElems = <>
                        {!props.noModal && <button className={`btn btn-success m-0 me-1 mt-1 ${processing ? "disabled" : ""}`} type="button" onClick={open}><i className="fa fa-plus"></i> Ajouter des Fichiers</button>}
                        {props.parentProps.noUploads ? "" : <button className={`btn btn-primary ${props.noModal ? "btn-sm" : ""} m-0 me-1 mt-1 ${(!props.noModal || localFiles.length) ? "" : "d-none"} ${processing ? "disabled" : ""}`} type="button" onClick={uploadFiles}><i className="fa fa-upload"></i> Démarrer le transfert</button>}
                        {props.parentProps.noUploads ? "" : <button className={`btn btn-warning ${props.noModal ? "btn-sm" : ""} m-0 me-1 mt-1 ${(!props.noModal || processing) ? "" : "d-none"} ${processing ? "" : "disabled"}`} type="reset" onClick={cancelUpload}><i className="fa fa-ban"></i> Annuler le transfert</button>}
                        <div className={`form-check form-check-inline fcheck-sm mt-2 ${props.parentProps.noTimestamp ? "d-none" : ""}`}>
                            <Label check for={"contentActive"} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                                <div className={`d-inline-block`}>
                                    <Input type="checkbox" id={"contentActive"} checked={timestamp} onChange={() => { setTimestamp(!timestamp); }} />
                                    <span className={`form-check-sign`} />
                                    <div className={`d-inline-block ms-4`}>Utiliser l'horodatage</div>
                                </div>
                            </Label>
                        </div>

                        <div className="hr-line-dashed"></div>
                    </>


                    return (
                        <section className={props.noModal ? "ged-dropzone-wrapper2" : ""}>

                            {localFilesType.length && !props.parentProps.noChooseTypes ? (props.noModal ? <div>{chooseTypeContent}</div> : chooseTypeContent) : ""}

                            {!props.noModal ? actionElems : ""}
                            <div {...getRootProps()} className={props.noModal ? "ged-dropzone position-relative p-1 mt-1" : ""} style={props.noModal ? { height: "20vh", overflow: "auto" } : {}}>
                                <input {...getInputProps()} />
                                {props.noModal ? <><div className="ged-dropzone-content text-center position-absolute align-content-center" style={{ inset: "0px" }}>
                                        <i className="fa fa-cloud-arrow-up fa-3x mb-3" style={{ color: "#00aaa8" }}></i>
                                        <div className="fw-semibold mb-1">Glissez-déposez vos fichiers ici</div>
                                        <div className="text-muted small">ou cliquez pour parcourir</div>
                                </div> {filesContent}</> : <div className="thumbsContainer">
                                    {filesContent}
                                </div>}
                            </div>
                            {props.noModal ? actionElems : ""}
                        </section>
                    );
                }}
            </Dropzone>
        </Col>
    </Row>;


    if (props.noModal) {
        return content;
    }
    else {
        return (
            <Modal isOpen={true} className="modal-files" size="xl" keyboard={false} toggle={() => { props.callback(localFiles); }} backdrop="static" style={{ paddingTop: "0px" }}>
                <ModalHeader className="d-flex" toggle={() => { props.callback(localFiles); }}>{props.title || "Transfert de Fichiers"}</ModalHeader>
                <ModalBody className="px-2">
                    <div className="d-inline-block" style={{ fontSize: '48px' }} >
                        <i className="fa fa-cloud-upload-alt"></i>
                    </div>

                    <p className="d-inline-block mt-1" style={{ fontSize: '15px', verticalAlign: "top" }}>Vous pouvez charger les documents et les associer à une catégorie</p>

                    {content}
                </ModalBody>
                <ModalFooter className="px-2 flex-nowrap">
                    <Progress className="w-100 float-end" color="success" style={{ height: '15px' }} value={(() => {
                        var valueLoaded = 0;
                        var valueTotal = 0;
                        localFiles.forEach(file => {
                            if (!file.closed) {
                                valueLoaded += (file.loaded || 0);
                                valueTotal += (file.size || 0);//total avait besoin qu'on passe une fois dans onUploadProgress pour chaque fichier (impossible en sequentiel)
                            }
                        });
                        return (valueLoaded / valueTotal * 100);
                    })()}></Progress>

                    <Button className="px-3" color="secondary" onClick={() => { props.callback(localFiles); }}>Fermer</Button>
                </ModalFooter>
            </Modal>
        );
    }
}